var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 13",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons-preferred-contact",
    transform: "translate(-340.000000, -384.000000)",
    fill: "#585D63"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-sms",
    transform: "translate(340.000000, 381.000000)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 17 3 C 18.657 3 20 4.343 20 6 L 20 12.727 C 20 14.384 18.657 15.727 17 15.727 L 3 15.727 C 1.343 15.727 0 14.384 0 12.727 L 0 6 C 0 4.343 1.343 3 3 3 L 17 3 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 4.963 12.224 L 3.682 6.855 L 4.791 6.855 L 5.601 10.543 L 6.582 6.855 L 7.871 6.855 L 8.812 10.605 L 9.636 6.855 L 10.728 6.855 L 9.424 12.224 L 8.274 12.224 L 7.205 8.21 L 6.139 12.224 Z M 11.294 12.224 L 11.294 6.855 L 12.378 6.855 L 12.378 9.239 L 14.568 6.855 L 16.026 6.855 L 14.004 8.946 L 16.136 12.224 L 14.733 12.224 L 13.257 9.704 L 12.378 10.602 L 12.378 12.224 Z",
    style: {
      fill: "rgb(255, 255, 255)",
      whiteSpace: "pre"
    }
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWk);
export default __webpack_public_path__ + "static/media/WK.3f647a54caae1eb556f2801ae7beaff9.svg";
export { ForwardRef as ReactComponent };